export const firebaseConfig = {
    apiKey: "AIzaSyBGH9TR0yLbmV6vuWtVOBhgpElupWwbd1Y",
    authDomain: "pukinn2.firebaseapp.com",
    databaseURL: "https://pukinn2.firebaseio.com",
    projectId: "pukinn2",
    storageBucket: "pukinn2.appspot.com",
    messagingSenderId: "298183340681",
    appId: "1:298183340681:web:e8823e2c9b0648ed5d8c58",
    measurementId: "G-D6RHYZHWN8"
};